//
// Copyright 2026 DXOS.org
//
import * as Schema from 'effect/Schema';
import * as Rpc from 'effect/unstable/rpc/Rpc';
import * as RpcGroup from 'effect/unstable/rpc/RpcGroup';
import { protoMessage, serviceError } from './service-rpc.js';
import { mutableArray, protoTimestamp } from './service-schemas.js';
//
// RPC message schemas.
//
export const ControlMetricsRequest = Schema.Struct({
    reset: Schema.optional(Schema.Boolean),
    record: Schema.optional(Schema.Boolean),
});
export const ControlMetricsResponse = Schema.Struct({
    recording: Schema.optional(Schema.Boolean),
});
export const QueryMetricsRequest = Schema.Struct({
    interval: Schema.optional(Schema.Number),
});
export const Value = Schema.Struct({
    bool: Schema.optional(Schema.Boolean),
    string: Schema.optional(Schema.String),
    int: Schema.optional(Schema.Number),
    float: Schema.optional(Schema.Number),
});
export const Stats = Schema.Struct({
    min: Schema.optional(Schema.Number),
    max: Schema.optional(Schema.Number),
    mean: Schema.optional(Schema.Number),
    median: Schema.optional(Schema.Number),
    total: Schema.optional(Schema.Number),
    count: Schema.optional(Schema.Number),
});
export const KeyPair = Schema.Struct({
    key: Schema.optional(Schema.String),
    value: Schema.optional(Value),
    stats: Schema.optional(Stats),
});
export const Metrics = Schema.Struct({
    timestamp: protoTimestamp,
    values: Schema.optional(mutableArray(KeyPair)),
});
export const QueryMetricsResponse = Schema.Struct({
    timestamp: protoTimestamp,
    metrics: Metrics,
});
/**
 * Effect RPC definitions for `dxos.client.services.LoggingService`.
 * Service-only payloads use Effect schemas; shared proto types remain protobuf-encoded on the wire.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('controlMetrics', {
    payload: ControlMetricsRequest,
    success: ControlMetricsResponse,
    error: serviceError,
}), Rpc.make('queryMetrics', {
    payload: QueryMetricsRequest,
    success: QueryMetricsResponse,
    error: serviceError,
    stream: true,
}), Rpc.make('queryLogs', {
    payload: protoMessage('dxos.client.services.QueryLogsRequest'),
    success: protoMessage('dxos.client.services.LogEntry'),
    error: serviceError,
    stream: true,
})).prefix('LoggingService.') {
}
//# sourceMappingURL=LoggingService.js.map